import axios from "@/plugins/axios"
import type { ShipmentBundle } from "@/types/shipment-bundle.type"

export interface CreateRequest {
  purchaseProductIds: number[]
  shipper: string | null
  trackingCode: string | null
  trackingLink: string | null
}

async function create(request: CreateRequest): Promise<ShipmentBundle> {
  const response = await axios.post<ShipmentBundle>("/shipment_bundles/create_with_purchase_products", request)
  return response.data
}

const shipmentBundleService = {
  create,
}

export default shipmentBundleService
